import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface CircleState {
  /**
   * Working circle point.
   * This is the center point of the circle being drawn.
   */
  workingCirclePoint?: [number, number, number]
}

const initialState: CircleState = {}

export const circleSlice = createSlice({
  name: 'blueprint-editor/tools/shapes/circle',
  initialState,
  reducers: {
    // ## Working circle state
    setWorkingCirclePoint(state, action: PayloadAction<[number, number, number] | undefined>) {
      state.workingCirclePoint = action.payload
    },

    undoWorkingCircle(state) {
      state.workingCirclePoint = undefined
    },

    // ## Reset state
    reset: () => initialState,
  },
})

export const { setWorkingCirclePoint, undoWorkingCircle, reset } = circleSlice.actions
export default circleSlice.reducer
